import * as types from '../mutation-types'

const state = {
  redStatus: false
}

// getters
const getters = {
  getRedStatus: state => state.redStatus
}

// actions
const actions = {
  setRedStatus ({ commit }, payload) {
    commit(types.RED_STATUS, payload)
  }
}

// mutations
const mutations = {
  [types.RED_STATUS] (state, status) {
    state.redStatus = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contract.js